import React from 'react';

const RowsPerPageSelector = ({ rowsPerPage, onRowsPerPageChange, options = [25, 50, 100] }) => {
  return (
    <div className="dataTables_length" id="examplemgm_length">
      <label>Show &nbsp;</label>
      <select value={rowsPerPage} name="examplemgm_length" onChange={(e) => onRowsPerPageChange(e.target.value)} style={{borderRadius:"9px", padding:"5px"}}>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      &nbsp;entries
    </div>
  );
};

export default RowsPerPageSelector;
